import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    /* コンテンツ情報 (content1, content2, content3 含む) */
    content: [],
    /* 階層1データ */
    kaiso1tbl: [],
    /* 階層2データ */
    kaiso2tbl: [],
    /* 階層3データ */
    kaiso3tbl: [],
    /* 選択中のメニューID 例）RC001/01 */
    //openMenuId: '',
    //openMenuId2: '',
    openMenuId: [],
    openMenuId2: [],

    /*表示ページ階層判断用*/
    selMenuId: '',
    selMenuId2: '',
  },
  getters: {
    content (state) {
      return state.content
    },
    kaiso1tbl (state) {
      return state.kaiso1tbl
    },
    kaiso2tbl (state) {
      return state.kaiso2tbl
    },
    kaiso3tbl (state) {
      return state.kaiso3tbl
    },
    openMenuId (state) {
      return state.openMenuId
    },
    openMenuId2 (state) {
      return state.openMenuId2
    },
    /*表示ページ階層判断用*/
    selMenuId (state) {
      return state.selMenuId
    },
    selMenuId2 (state) {
      return state.selMenuId2
    }

  },
  mutations: {
    setContent (state, payload) {
      state.content = payload.content
    },
    setKaiso1tbl (state, payload) {
      state.kaiso1tbl = payload.kaiso1tbl
    },
    setKaiso2tbl (state, payload) {
      state.kaiso2tbl = payload.kaiso2tbl
    },
    setKaiso3tbl (state, payload) {
      state.kaiso3tbl = payload.kaiso3tbl
    },

    //第一階層
    setOpenMenuId (state, payload) {
      state.openMenuId.push(payload.openMenuId)
    },
    delOpenMenuId (state, payload) {
      const index = state.openMenuId.findIndex((MenuId) => MenuId === payload.openMenuId)
      if (index !== -1 ) {
        state.openMenuId.splice(index, 1)
      }
    },
    initOpenMenuId (state, payload) {
      state.openMenuId.splice(0)
    },
    //第二階層
    setOpenMenuId2 (state, payload) {
      state.openMenuId2.push(payload.openMenuId2)
    },
    delOpenMenuId2 (state, payload) {
      const index = state.openMenuId2.findIndex((MenuId) => MenuId === payload.openMenuId2)
      if (index !== -1 ) {
        state.openMenuId2.splice(index, 1)
      }
    },
    initOpenMenuId2 (state, payload) {
      state.openMenuId2.splice(0)
    },

    /* 表示ページ階層判断用 */
    setSelMenuId (state, payload) {
      state.selMenuId = payload.selMenuId
    },
    setSelMenuId2 (state, payload) {
      state.selMenuId2 = payload.selMenuId2
    }

  },
  actions: {
    upContent ({ commit }, content) {
      commit('setContent', { content })
    },
    upKaiso1tbl ({ commit }, kaiso1tbl) {
      commit('setKaiso1tbl', { kaiso1tbl })
    },
    upKaiso2tbl ({ commit }, kaiso2tbl) {
      commit('setKaiso2tbl', { kaiso2tbl })
    },
    upKaiso3tbl ({ commit }, kaiso3tbl) {
      commit('setKaiso3tbl', { kaiso3tbl })
    },
   
    //第一階層
    upOpenMenuId ({ commit }, openMenuId) {
      commit('setOpenMenuId', { openMenuId })
    },
    dlOpenMenuId ({ commit }, openMenuId) {
      commit('delOpenMenuId', { openMenuId })
    },
    delAllOpenMenuId ({ commit }, openMenuId) {
      commit('initOpenMenuId', { openMenuId })
    },
    //第二階層
    upOpenMenuId2 ({ commit }, openMenuId2) {
      commit('setOpenMenuId2', { openMenuId2 })
    },
    dlOpenMenuId2 ({ commit }, openMenuId2) {
      commit('delOpenMenuId2', { openMenuId2 })
    },
    delAllOpenMenuId2 ({ commit }, openMenuId2) {
      commit('initOpenMenuId2', { openMenuId2 })
    },

    /*表示ページ階層判断用*/
    upSelMenuId ({ commit }, selMenuId) {
      commit('setSelMenuId', { selMenuId })
    },
    upSelMenuId2 ({ commit }, selMenuId2) {
      commit('setSelMenuId2', { selMenuId2 })
    },


  }
})
export default store
